import React, { useMemo } from 'react'
import { Flex, Popover, Typography } from 'antd'
import IconReportsSettings from '../../components/ui/icons/IconReportsSettings'
import IconArrowDownSmall from '../../components/ui/icons/IconArrowDownSmall'
import IconReportsTagClose from '../../components/ui/icons/IconReportsTagClose'
import { t } from 'i18next'
import SettingsPopup from './SettingsPopup'
import useChannels from './useChannels'
import { UserValue } from './index'
import { KpiColumnsShow } from './IndicatorsComparison'

const { Text } = Typography

type Channel = {
  name: string,
  id: string,
}

interface SettingsProps {
  selectedChannelsIds: string[],
  setSelectedChannelsIds: Function,
  companies: UserValue[],
  engineId?: number,
  kpiColumns: KpiColumnsShow;
  setKpiColumns: React.Dispatch<React.SetStateAction<KpiColumnsShow>>
}

export default function IndicatorsComparisonSettings ({
  selectedChannelsIds,
  setSelectedChannelsIds,
  companies,
  engineId,
  kpiColumns,
  setKpiColumns,
}: SettingsProps) {
  const { channels } = useChannels(companies, engineId)

  const selectedChannels: Channel[] = useMemo(() => {
    return channels.filter((channel: Channel) => selectedChannelsIds.includes(channel.id))
  }, [channels, selectedChannelsIds])

  return (
    <Flex className={'reports-settings'} align={'flex-start'} justify={'flex-start'} gap={6}>
      <Popover placement="bottomLeft" content={
        <div className={'settings-popover'}>
          <SettingsPopup
            channels={channels}
            setSelectedChannelsIds={setSelectedChannelsIds}
            selectedChannelsIds={selectedChannelsIds}
            kpiColumns={kpiColumns}
            setKpiColumns={setKpiColumns}
          />
        </div>
      } arrow={false}>
        <Flex className={'reports-settings__button'} align={'center'}>
          <IconReportsSettings/>
          <span className={'reports-settings__button-text'}>{t('reports.setView')}</span>
          <IconArrowDownSmall/>
        </Flex>
      </Popover>

      <Flex className={'reports-settings__channels'}>
        {selectedChannels.map((channel: Channel) => (
          <Flex className={'reports-settings__channel'} align={'center'} key={channel.id}>
            <Text
              ellipsis={{ tooltip: channel.name }}
            >
              <span className={'reports-settings__channel-text'}>{channel.name}</span>
            </Text>


            <Flex className={'reports-settings__channel-close'} onClick={() => {
              setSelectedChannelsIds(
                selectedChannelsIds.filter((channelId: string) => channelId !== channel.id)
              )
            }}>
              <IconReportsTagClose/>
            </Flex>

          </Flex>
        ))}
      </Flex>
    </Flex>
  )
}
